<template lang="pug">
  b-modal#editRewardRainSession(
  ref="editRewardRainSession"
  :title="$t('ui.combine.edit_reward_rain_session')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  size="lg"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      div.row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.name')").mb-0
            DebounceInput(
              size="sm"
              ref="name"
              required
              type="text"
              :dirty="$v.name.$dirty"
              :error="$v.name.$error"
              v-model.trim.lazy="$v.name.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.name" :name="$t('ui.name')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.campaign_id')").mb-0
            CampaignLookup(
              size="sm"
              ref="campaign_id"
              required
              type="array"
              :dirty="$v.campaign_id.$dirty"
              :error="$v.campaign_id.$error"
              v-model.trim.lazy="$v.campaign_id.$model"
              :disabled="loading"
              :operatorID="operatorID"
            )
            ValidateResult(:value="$v.campaign_id" :name="$t('ui.campaign_id')")
      div.row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.start_date')").mb-0
            b-input-group(size="sm")
              date-picker.form-control-sm(
                ref="start_date"
                :config="localeDate"
                :dirty="$v.start_date.$dirty"
                :error="$v.start_date.$error"
                v-model.trim.lazy="$v.start_date.$model"
                :disabled="loading"
              )
            ValidateResult(:value="$v.start_date" :name="$t('ui.start_date')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.start_time')").mb-0
            b-input-group(size="sm")
              date-picker.form-control-sm(
                ref="start_time"
                :config="localeTime"
                :dirty="$v.start_time.$dirty"
                :error="$v.start_time.$error"
                v-model.trim.lazy="$v.start_time.$model"
                :disabled="loading"
              )
            ValidateResult(:value="$v.start_time" :name="$t('ui.start_time')")
      div.row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.end_date')").mb-0
            b-input-group(size="sm")
              date-picker.form-control-sm(
                ref="end_date"
                :config="localeDate"
                :dirty="$v.end_date.$dirty"
                :error="$v.end_date.$error"
                v-model.trim.lazy="$v.end_date.$model"
                :disabled="loading"
              )
            ValidateResult(:value="$v.end_date" :name="$t('ui.end_date')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.end_time')").mb-0
            b-input-group(size="sm")
              date-picker.form-control-sm(
                ref="end_time"
                :config="localeTime"
                :dirty="$v.end_time.$dirty"
                :error="$v.end_time.$error"
                v-model.trim.lazy="$v.end_time.$model"
                :disabled="loading"
              )
            ValidateResult(:value="$v.end_time" :name="$t('ui.end_time')")
      div.row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.min_amount')").mb-0
            DebounceInput(
              size="sm"
              ref="min_amount"
              type="text"
              :dirty="$v.min_amount.$dirty"
              :error="$v.min_amount.$error"
              v-model.trim.lazy="$v.min_amount.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.min_amount" :name="$t('ui.min_amount')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.max_amount')").mb-0
            DebounceInput(
              size="sm"
              ref="max_amount"
              type="text"
              :dirty="$v.max_amount.$dirty"
              :error="$v.max_amount.$error"
              v-model.trim.lazy="$v.max_amount.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.max_amount" :name="$t('ui.max_amount')")
      div.row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.reward_count')").mb-0
            DebounceInput(
              size="sm"
              ref="reward_count"
              type="text"
              :dirty="$v.reward_count.$dirty"
              :error="$v.reward_count.$error"
              v-model.trim.lazy="$v.reward_count.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.reward_count" :name="$t('ui.reward_count')")
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minValue, integer } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CampaignLookup from "@/library/CampaignLookup";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CampaignLookup
  },
  props: {
    item: {
      type: Object
    },
    operatorID: {
      type: String
    }
  },
  data() {
    return {
      name: "",
      session_id: "",
      campaign_id: "",
      start_date: this.$moment(new Date).format('YYYY-MM-DD'),
      end_date: this.$moment(new Date).format('YYYY-MM-DD'),
      start_time: "00:00:00",
      end_time: "23:59:59",
      localeDate: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      localeTime: {
        format: "HH:mm:ss",
        useCurrent: true
      },
      min_amount: "",
      max_amount: "",
      reward_count: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    name: {
      required
    },
    campaign_id: {
      required
    },
    start_date: {
      required
    },
    end_date: {
      required
    },
    start_time: {
      required
    },
    end_time: {
      required
    },
    min_amount: {
      required,
      minValue: minValue(1),
      integer
    },
    max_amount: {
      required,
      minValue(value) {
        return minValue(Math.max(1, this.min_amount))(value)
      },
      integer
    },
    reward_count: {
      required,
      minValue: minValue(1),
      integer
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.rewardRainSessionEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          session_id: this.session_id,
          session_name: this.name,
          campaign_id: this.campaign_id,
          start_time: this.start_date + ' ' + this.start_time,
          end_time: this.end_date + ' ' +this.end_time,
          min_amount: this.min_amount,
          max_amount: this.max_amount,
          reward_count: this.reward_count
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editRewardRainSession.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_reward_rain_session", this.feedback.status);
                  this.$refs.editRewardRainSession.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.session_id = this.item.id;
      this.campaign_id = this.item.campaign_id;
      this.name = this.item.rrs_name;
      this.start_date = this.$moment(this.item.start_at).format('YYYY-MM-DD');
      this.end_date = this.$moment(this.item.end_at).format('YYYY-MM-DD');
      this.start_time = this.$moment(this.item.start_at).format('HH:mm:ss');
      this.end_time = this.$moment(this.item.end_at).format('HH:mm:ss');
      this.min_amount = this.item.min_amount;
      this.max_amount = this.item.max_amount;
      this.reward_count = this.item.reward_count;
      this.$refs.name.$el.focus();
    }
  }
};
</script>
